import { ReactElement, useState, useEffect } from "react";
import { Container } from "reactstrap";
import { useTranslation } from "react-i18next";
import useListColumns from "@hooks/Clients/WhaleShark/glance/useListColumns";
import deleteItem from "@services/Clients/WhaleShark/benefits/deleteItem";
import useDeleteItem from "@hooks/Shared/useDeleteItem";
import ModalConfirmation from "@components/ModalConfirmation";
import CreateBtn from "@components/CreateButton";
import Loader from "@components/Loader";
import Table from "@components/Table";
import Title from "@components/Title";
import { EUiStates } from "@constants/enum";
import getItems from "@services/Clients/WhaleShark/benefits/getItems";
import listMapper from "@mappers/Clients/WhaleShark/benefits/list.mapper";
import useListItems from "@hooks/Shared/useListItems";

const ListItems = (): ReactElement => {
  const { t } = useTranslation(["core", "whaleshark"]);
  const [isDeletingItem, setIsDeletingItem] = useState(false);
  const { isLoading, basicData, tableItems } = useListItems(
    isDeletingItem,
    getItems,
    listMapper,
    true
  );
  const { isModalOpen, isDeleting, handleDelete, handleIsModalOpen } =
    useDeleteItem(basicData);
  const COLUMNS = useListColumns();

  useEffect(() => {
    setIsDeletingItem(isDeleting);
  }, [isDeleting]);

  if (isLoading) {
    return <Loader />;
  }

  return (
    <Container>
      <ModalConfirmation
        icon="trash"
        title={`${t("whaleshark:common.benefits")} | ${t(
          "core:common.delete_confirm"
        )}`}
        body={`${t("core:notifications.delete_message")} "${
          basicData?.description
        }" ?`}
        handleConfirm={() => {
          handleDelete(deleteItem);
        }}
        handleModalStatus={handleIsModalOpen}
        modalStatus={isModalOpen}
        modalType={EUiStates.DANGER}
      />

      <Title />
      <CreateBtn />
      <Table columns={COLUMNS} items={tableItems} />
    </Container>
  );
};

export default ListItems;
